import { Icon, IconType, Link } from '@msaf/core-react'
import MapMenuButton from './map-menu-button'
import { MapPanels } from '@msaf/maps-react'

export interface MapPanelDisplayOptions {
  isSearchEnabled?: boolean
  isLocationEnabled?: boolean
  isFeaturesEnabled?: boolean
  isLayersEnabled?: boolean
}

export interface MapMenuProps extends MapPanelDisplayOptions {
  updatePanelState: Function
  activePanel?: string | false
  appliedFilterCount?: number
  appLogo?: IconType | JSX.Element
}

export default function MapMenu({
  isSearchEnabled = true,
  isLocationEnabled = true,
  isFeaturesEnabled = true,
  isLayersEnabled = true,
  updatePanelState,
  activePanel,
  appliedFilterCount,
  appLogo,
}: MapMenuProps) {
  return (
    <nav className='c-map-menu'>
      {appLogo && typeof appLogo === 'string' ? (
        <div className='c-map-menu__app-logo'>
          <Link path='/' exact={true} className='c-app-logo__link'>
            <span className='c-app-logo__bg-circle'>
              <Icon icon={appLogo} className='c-app-logo__icon' ariaHidden={true} />
            </span>
          </Link>
        </div>
      ) : (
        appLogo
      )}

      <ul className='c-map-menu__items'>
        {isSearchEnabled && (
          <li className='c-map-menu__item'>
            <MapMenuButton
              panelName={MapPanels.SEARCH}
              buttonIcon='search'
              updatePanelState={updatePanelState}
              activePanel={activePanel}
              appliedFilterCount={appliedFilterCount}
            />
          </li>
        )}
        {isLocationEnabled && (
          <li className='c-map-menu__item'>
            <MapMenuButton
              panelName={MapPanels.LOCATION}
              buttonIcon='location'
              updatePanelState={updatePanelState}
              activePanel={activePanel}
            />
          </li>
        )}
        {isFeaturesEnabled && (
          <li className='c-map-menu__item'>
            <MapMenuButton
              panelName={MapPanels.FEATURES}
              buttonIcon='marquee'
              updatePanelState={updatePanelState}
              activePanel={activePanel}
            />
          </li>
        )}
        {isLayersEnabled && (
          <li className='c-map-menu__item'>
            <MapMenuButton
              panelName={MapPanels.LAYERS}
              buttonIcon='layers'
              updatePanelState={updatePanelState}
              activePanel={activePanel}
            />
          </li>
        )}
      </ul>
    </nav>
  )
}
